
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorPlaceholderIcon as ObiCursorPlaceholderIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-placeholder-icon.js';
 
 
 

 
 export const ObiCursorPlaceholderIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-placeholder-icon',
   elementClass: ObiCursorPlaceholderIconElement,
   events: {
     
   }
  });
 
 